import { validateEmail, validateURL } from "./functions";

export const handleValidation = (conditions) => {
    let errors = {};
    let isError = false;
    const uppercaseRegex = /[A-Z]/;
    const lowercaseRegex = /[a-z]/;
    const numberRegex = /\d/;
    const specialCharRegex = /[@#$%^&+=!]/;
    for (let i = 0; i < conditions.length; i++) {
        let obj = conditions[i];
        switch (obj.condition) {
            case 'required':
                if (!obj.value) {
                    errors[conditions[i].name] = conditions[i].text + ' Required';
                    isError = true;
                }
                break;
            case 'email':
                if (obj.value && !validateEmail(obj.value)) {
                    errors[conditions[i].name] = 'Invalid Email';
                    isError = true;
                }
                break;
            case 'number':
                if (obj.value && isNaN(obj.value)) {
                    errors[conditions[i].name] = 'Should be Number';
                    isError = true;
                }
                break;
            case 'url':
                if (obj.value && !validateURL(obj.value)) {
                    errors[conditions[i].name] = 'Invalid Url';
                    isError = true;
                }
                break;
            case 'match':
                if (obj.value && obj.value2 && obj.value !== obj.value2) {
                    errors[conditions[i].name] = conditions[i].text + ' Not Matching';
                    isError = true;
                }
                break;
            case 'minlength':
                if (obj.value && (obj.min > obj.value.length)) {
                    errors[conditions[i].name] = 'Should be ' + obj.min + ' or more Characters';
                    isError = true;
                }
                break;
            case 'strongPassword':
                if (obj.value) {
                    let pass_errors = [];
                    if (!uppercaseRegex.test(obj.value)) {
                        pass_errors.push('at least 1 uppercase letter');
                    }
                    if (!lowercaseRegex.test(obj.value)) {
                        pass_errors.push('at least 1 lowercase letter');
                    }
                    if (!numberRegex.test(obj.value)) {
                        pass_errors.push('at least 1 number');
                    }
                    if (!specialCharRegex.test(obj.value)) {
                        pass_errors.push('at least 1 special character (!,@,#,$,etc.)');
                    }
                    if (pass_errors.length > 0) {
                        errors[obj.name] = 'Password should contain: ' + pass_errors.join(', ');
                        isError = true;
                    }
                }
                break;

            default:
                break;
        }
    }
    return { isError, errors };
}